import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ShoppingCart } from '@components/templates/shoppingCart';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useGetCart } from '@services/useGetCart';
import { useData } from '@hooks/useData';
import useCartSummary from '@hooks/useCartSummary';
import { useUpdateProductInCart } from '@services/useUpdateProductInCart';

export function ShoppingCartPage() {
    const { request: requestCart } = useGetCart();
    const { request: requestUpdateProductInCart } = useUpdateProductInCart();

    const { cart, login, user } = useData();
    const { t, i18n } = useTranslation();
    const { formattedCart } = useCartSummary(cart?.data);

    const isLoggedIn = !!login?.data;
    const isMinor = isLoggedIn && !user?.data?.over18;

    useEffect(() => {
        if (!isMinor || !cart?.data?.productsByMerchant) return;

        cart.data.productsByMerchant.forEach((merchant) => {
            (merchant.cartItems || []).forEach((item) => {
                if (item?.product?.over18) {
                    requestUpdateProductInCart({ cart_item_uuid: item.uuid, quantity: 0 });
                }
            });
        });
    }, [isMinor, cart?.data?.productsByMerchant, requestUpdateProductInCart]);

    const translations = {
        title: t('shopping-cart-component.metatags.title'),
        description: t('shopping-cart-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.shoppingCart,
        index: false,
    });

    // request services, when entering page
    useEffect(() => {
        requestCart({});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    const total = formattedCart();

    return (
        <ShoppingCart
            productsByMerchant={cart?.data?.productsByMerchant || []}
            hasOutOfStockItem={cart?.data?.hasOutOfStockItem || false}
            total={total}
        />
    );
}
